import { logger as LOG } from '@sweetgreen/garnish';

export const logger = LOG.extend('LAUNCHDARKLY');

LOG.disable('LAUNCHDARKLY');
